import * as React from 'react';

import UploadCloud140 from './UploadCloud140';

export const uploadCloud140 = () => <UploadCloud140 />;

export default {
    title: 'Illustration/UploadCloud140',
    component: UploadCloud140,
    parameters: {
        notes: "`import UploadCloud140 from 'box-ui-elements/es/illustration/UploadCloud140';`",
    },
};
